<template>
    <div>
        <v-img
            class="white--text align-top"
            height="250px"
            gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
            :src="`/images/farmacia.png`"
        >
            <v-card-title justify-top>
                Farmacia
            </v-card-title>
        </v-img>

        <v-tabs color="primary" v-model="tab">
            <v-tab>
                Existencias
            </v-tab>
            <v-tab>
                Movimientos
            </v-tab>
            <v-tab v-if="tieneAccesoColectivos">
                Colectivos
            </v-tab>
            <v-tab v-if="tieneAccesoEntradas">
                Existencias Medicamentos
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <farmacia-existencias/>
            </v-tab-item>
            <v-tab-item>
                <farmacia-movs/>
            </v-tab-item>
            <v-tab-item v-if="tieneAccesoColectivos">
                <farmacia-colectivos/>
            </v-tab-item>
            <v-tab-item v-if="tieneAccesoEntradas">
                <farmacia-entradas/>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<script>
export default {
    components:{
        'farmacia-existencias':()=>import('@/components/farmacia/FarmaciaLista'),
        'farmacia-movs':()=>import('@/components/farmacia/FarmaciaReporteMovs'),
        'farmacia-entradas':()=>import('@/components/farmacia/FarmaciaEntradas').catch(e => {
            console.error('Error cargando FarmaciaEntradas:', e)
            return null
        }),
    },
    data:()=>({
        tab:0,
    }),
    computed: {
        tieneAccesoColectivos() {
            const roles = ['ROLE_ADMIN', 'ROLE_FARMACIA_COLECTIVOS', 'ROLE_FARMACIA_ADMIN', 'ROLE_ENFERMERIA', 'ROLE_ENFERMERIA_ADMIN']
            const userRoles = this.$store?.state?.security?.roles || []
            return roles.some(role => userRoles.includes(role))
        },
        tieneAccesoEntradas() {
            const roles = ['ROLE_ADMIN', 'ROLE_FARMACIA_ADMIN']
            const userRoles = this.$store?.state?.security?.roles || []
            return roles.some(role => userRoles.includes(role))
        }
    },
}
</script>

<style>

</style>